import React from "react";
import Container from "@material-ui/core/Container";

const SectionContainer = ({ children, overwriteMaxWidth }) => (
    <Container maxWidth={(overwriteMaxWidth) ? "md" : "sm"}>
        {children}
    </Container>
);

export default SectionContainer;